// extracted by mini-css-extract-plugin
export default {"link":"All_link__1aTdQ","nav":"All_nav__wJxcw"};